import * as React from "react";
import styled from "styled-components";
import { VoucherCard, VoucherContainer } from "./styles";
import { getShowVoucherImgType } from "./utils";
import { isNotBlankArray } from "../../../utils/array";
import ImageView from "../../../components/SmartImage";
const VoucherItem = styled.div `
	margin: 0 auto;
	overflow: hidden;
	width: 1077px;
	display: flex;
	flex-wrap: wrap;
	box-sizing: border-box;
	& > div {
		padding-top: 12px;
		padding-right: 24px;
		box-sizing: border-box;
		&:nth-child(3n) {
			padding-right: 0;
		}
	}
`;
export const VoucherCardThree = styled(VoucherCard) `
	width: 33.3%;
	min-height: 195px;

	&.expired {
		.voucherImg {
			filter: grayscale(100%);
			opacity: 0.8;
		}
		& > .controllerArea {
			position: relative;
			background-color: #ddd !important;
			color: #7d7d7d !important;
			cursor: pointer;
		}
	}

	.voucherImg {
		width: 100%;
		height: 100%;
		display: block;
	}

	.controllerArea {
		position: relative;
		font-size: 24px;
		font-weight: 600;
		height: 65px;
		text-align: center;
		color: #fff;
		cursor: pointer;

		&:before {
			content: "";
			display: block;
			width: 100%;
			height: 1px;
			background-image: linear-gradient(to right, #fff 0%, #fff 50%, transparent 50%);
			background-size: 15px 1px;
			background-repeat: repeat-x;
			position: absolute;
			left: 0;
			top: -1px;
		}
		& > .stamp {
			position: absolute;
			right: 10%;
			bottom: 15px;
			width: 134px;
		}
		& > i {
			bottom: 52px;
		}
	}
`;
export default class VoucherThree extends React.Component {
    constructor() {
        super(...arguments);
        this.renderVoucherCom = (voucher, index) => {
            var _a;
            const { onClaimVoucher, online, callbackText, icon, baseColor } = this.props;
            const { ui, img, voucherState, link, voucherId, height } = voucher;
            const { isExhaust, isExpired, isClaimed } = getShowVoucherImgType(voucher);
            return (React.createElement(VoucherCardThree, { className: `${isExhaust || isExpired ? "expired" : ""}`, key: `${voucherId}_${index}` },
                React.createElement(ImageView, { src: img || "", imgClass: "voucherImg", isLazyLoad: true, aliSize: 4, online: online, style: { height } }),
                React.createElement("div", { className: "controllerArea", style: { backgroundColor: ui === null || ui === void 0 ? void 0 : ui.bgColor, color: (_a = ui === null || ui === void 0 ? void 0 : ui.colorTable) === null || _a === void 0 ? void 0 : _a.textColor } },
                    React.createElement("a", { onClick: () => onClaimVoucher(voucher) }, callbackText(voucherState, !!link)),
                    React.createElement("img", { src: icon, className: "stamp", style: { display: isClaimed ? "block" : "none" }, alt: "" }),
                    React.createElement("i", { className: "dotLeft", style: { backgroundColor: baseColor || "#f7f7f7" } }),
                    React.createElement("i", { className: "dotRight", style: { backgroundColor: baseColor || "#f7f7f7" } }))));
        };
    }
    render() {
        const { vouchers, positionId } = this.props;
        const hasValidVoucher = isNotBlankArray(vouchers);
        return (React.createElement(React.Fragment, null, hasValidVoucher && (React.createElement(VoucherContainer, { id: positionId },
            React.createElement(VoucherItem, null, vouchers.map((item, index) => this.renderVoucherCom(item, index)))))));
    }
}
